<template>
  <form>
    <div id="div-anthropometric-simple-form" class="vs-con-loading__container">
      <vs-row>
        <vs-col vs-type="flex" vs-align="center" vs-lg="4" vs-sm="12" vs-xs="12">
          <vs-input-number v-model="data.weightInKg" label="Peso (kg):" />
        </vs-col>

        <vs-col vs-type="flex" vs-align="center" vs-lg="4" vs-sm="12" vs-xs="12">
          <vs-input-number v-model="data.heightOrLengthInCentimeter" label="Estatura (cm):" />
        </vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-lg="4" vs-sm="12" vs-xs="12">
          <p>Medido em pé? &nbsp;</p>
          <vs-switch
            color="dark"
            icon-pack="feather"
            vs-icon-on="icon-check-circle"
            vs-icon-off="icon-slash"
            v-model="data.measuredStanding"
          >
            <span slot="on">Sim</span>
            <span slot="off">Nao</span>
          </vs-switch>
        </vs-col>
      </vs-row>

      <br />

      <vs-row>
        <vs-col vs-type="flex" vs-align="right" vs-lg="12" vs-sm="12" vs-xs="12">
          <vs-button @click="submit">Enviar</vs-button>
        </vs-col>
      </vs-row>
    </div>
  </form>
</template>

<script>
// import { Validator } from 'vee-validate';

// Service
import AnthropometricEvaluationService from "../../../../services/AnthropometricEvaluationService";

export default {
  components: {},
  props: {
    idAppointment: {
      // type: Number,
      required: true
    }
  },
  data() {
    return {
      data: {
        id: 0,
        idAppointment: 0,
        weightInKg: 0.0,
        heightOrLengthInCentimeter: 0.0,
        measuredStanding: false
      },
      notifications: {
        notify: this.$vs.notify,
        dialog: this.$vs.dialog,
        errors: this.errors,
        showSucces: false,
        showError: true
      },
      defaultDivId: "div-anthropometric-simple-form"
    };
  },
  mounted: function() {
    this.data.idAppointment = this.$props.idAppointment;
    this.get();
  },
  methods: {
    async submit() {
      console.log(this.data.id);
      if (this.data.id != null && this.data.id > 0) {
        await this.update();
      } else {
        await this.create();
      }

      this.$emit("AnthropometricEvaluationChanged", null);

      await this.get();
    },
    async get() {
      console.log("get", this.data.idAppointment);
      this.openLoadingInDiv(this.defaultDivId);

      const payload = {
        data: {
          idAppointment: this.data.idAppointment
        },
        notifications: this.notifications
      };

      payload.notifications.showSucces = false;
      payload.notifications.showError = false;

      var result = await AnthropometricEvaluationService.getByAppointmentId(
        payload
      );

      console.log(result);
      if (result.status == 200) {
        if (result.data.result != null) {
          this.data = result.data.result;
        }
      }

      this.closeLoadingDiv(this.defaultDivId);
    },
    async create() {
      this.openLoadingInDiv(this.defaultDivId);

      const payload = {
        data: this.data,
        notifications: this.notifications
      };

      console.log(payload);

      payload.notifications.showSucces = true;
      payload.notifications.showError = true;

      await AnthropometricEvaluationService.create(payload);

      this.closeLoadingDiv(this.defaultDivId);
    },
    async update() {
      this.openLoadingInDiv(this.defaultDivId);

      const payload = {
        data: this.data,
        notifications: this.notifications
      };

      payload.notifications.showSucces = true;
      payload.notifications.showError = true;

      await AnthropometricEvaluationService.update(payload);

      this.closeLoadingDiv(this.defaultDivId);
    },
    openLoadingInDiv(divId) {
      this.$vs.loading({
        container: "#" + divId,
        scale: 0.6
      });
    },
    closeLoadingDiv(divId) {
      this.$vs.loading.close("#" + divId + " > .con-vs-loading");
    }
  }
};
</script>

<style scoped>
.label {
  padding-left: 5px;
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.7);
}
</style>